export default "__VITE_ASSET__15Va5fdI__"